<template>
  <div class="selectTag-component" :class="customClassName">
    <div class="tag-cont">
        
      <el-tag
        :key="tag.label"
        v-for="(tag,idx) in tagList"
        closable
        :disable-transitions="false"
        class="tag-item"
        @close="handleClose(idx)">
        {{tag.value}}
      </el-tag>
      <div class="search-cont" v-if="tagList.length<limit">
        <el-tag v-if="!addShow" @click.native="addTagClick" class="tag-item">{{addTagTxt}}</el-tag>
        <!-- <el-button  v-if="!addShow"  @click="addTagClick" class="tag-item" size="small">{{addTagTxt}}</el-button> -->
        <el-autocomplete
          v-if="addShow"
          class="inline-input"
          ref="searchInput"
          :debounce="debounce"
          v-model="query"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          :maxlength="maxlength"
          :trigger-on-focus="false"
          @keydown.enter.native="creatTag"
          @select="handleSelect"
          @blur="tagBlur"
        ></el-autocomplete>
      </div>
    </div>
  </div>
</template>
<script >

// import { OrgControllerApi
// } from "typings/user_api";
export default {
  // @Prop({default:[]}) initTagList//回显tag
  // @Prop({default:true}) isTrim//是否删除前后空格
  // @Prop({default:1000}) debounce//延迟时间
  // @Prop({default:true}) autoFouse//自动获取焦点
  // @Prop({default:''}) customClassName//盒子class
  // @Prop({default:'+New Tag'}) addTagTxt//addtext
  // @Prop({default:20}) limit//限制条数

  props: {
    initTagList:{
      type:[Array,Object],
      default:[]
    },
    isTrim:{
      type:Boolean,
      default:true
    },
    debounce:{
      type:Number,
      default:1000
    },
    autoFouse:{
      type:Boolean,
      default:true
    },
    customClassName:{
      type:String,
      default:''
    },
    addTagTxt:{
      type:String,
      default:'+New Tag'
    },
    limit:{
      type:[Number,String],
      default:20
    },
    maxlength:{
      type:[Number,String],
      default:10
    }
  },
  data() {
    return {
          
      // tagList
      tagList: [
        // {label:'新标签',value:"1"},
      ],
      query:"",
      restaurants:[],

      isAll:true,

      addShow:false,

      selectTimer:0,//选择的定时器

      queryTimer:0,

      autofocus:false
    }
  },
  watch:{
    initTagList(val){
      this.tagList=val
    }
  },
  methods:{
    addTagClick () {
      this.addShow=true; 
      // console.info(this.autoFouse)
      if(this.autoFouse){//是否自动获取焦点
        this.$nextTick(()=>{
          // console.info(this.$refs.searchInput,'this.$refs.searchInput')
          this.$refs.searchInput.focus()
        })
      }
    },
      // enter创建
      creatTag(){
        // console.info(this.query,1)
        if(this.tagList.length>=this.limit){
          this.query=""
          return 
        }
        if(this.isAll){
          //为空时不创建
          if(this.query==""){
            return 
            // this.$message({
            //   type:'error',
            //   message:"不能创建空标签",
            //   customClass:'select-tag-message'
            // })
          }
          let isHave=false
          // 下拉数据是否包含
          let obj=this.getQueryTag(this.restaurants,this.query)
            console.info(obj,'obj')
          if(obj.value){
            // tagList是否包含
            let objChild=this.getQueryTag(this.tagList,obj.value)
            if(!objChild.label){
              this.tagList.push({label:obj.label,value:obj.value})
              this.$emit("initFuc",this.tagList)
              this.$nextTick(()=>{
                this.addShow=false   
                this.query=""   

              })
            }else{
              this.$message({
                type:'error',
                message:"该标签已添加",
                customClass:'select-tag-message'
              })
              this.query=""   
            }
          }else{
            let objChild=this.getQueryTag(this.tagList,this.query)
            // console.info(objChild,'objChild')
            if(!objChild.label){
              this.tagList.push({
                label:this.isTrim?this.query.trim():this.query,
                value:this.isTrim?this.query.trim():this.query,
                type:'newTag'
              })
              this.$emit("initFuc",this.tagList)
              this.$nextTick(()=>{
                this.addShow=false   
                this.query=""   

              })
            }else{
              this.$message({
                type:'error',
                message:"该标签已添加",
                customClass:'select-tag-message'
              }) 
              this.query="" 
            }
          }
          // console.info(this.tagList)
        }
      },
      filterTag(type,query){
        this[type]=this[type].filter(item=>{
          if(this.isTrim){
              
            if(item.value!=query.trim()){
              return item
            }
          }else{
            if(item.value!=query){
              return item
            }
          }
        })
      },
      getQueryTag(arr,query){
        let isHave=false
        let obj={}
        arr.map(item=>{
          if(this.isTrim){
            if(item.value==query.trim()){
              isHave=true
              obj=item
            }
          }else{
            if(item.value==query){
              isHave=true
              obj=item
            }
          }
        })
        return obj
      },
      querySearch(queryString, cb) {
        // console.info(queryString)
        clearTimeout(this.queryTimer)
        // this.queryTimer=setTimeout(()=>{
            
        //   let restaurants = this.restaurants;
        //   let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        //   // 调用 callback 返回建议列表的数据
        //   cb(results);
        // },1000)
        
          // let restaurants = this.restaurants;
          // let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
          // 调用 callback 返回建议列表的数据
          this.searchTag(queryString,()=>{
            cb(this.restaurants);
          })
      },
      
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      
      searchTag(searchword,cb) {
        // /onelink.mdata.ucenterconfiGeg.api/queryCustomTag
        
        this.$axios.post('/onelink.mdata.main.api/tag/findAllTags', {
            kwd:searchword,
            pageSize:100,
            pageNo:1
          }).then((res) => {
            // console.info(res)
           if (res.data.success) {
              let list = res.data.rows||[];
              this.restaurants=[]
              list.map(item=>{
                this.restaurants.push({
                  label:item.id,
                  value:item.tagName
                })
              })
              cb&&cb()
            }
        }).catch((err) => {
          console.log(err)
        })
        // OrgControllerApi.queryCustomTagUsingGET({ seach: searchword }).then(res => {
        //     if (res.body.code == 0) {
        //       let list = res.body.rows||[];
        //       this.restaurants=[]
        //       list.map(item=>{
        //         this.restaurants.push({
        //           label:item.tagCode,
        //           value:item.tagName
        //         })
        //       })
        //       cb&&cb()
        //     }
        // });
      },
      loadAll() {
        return [
          { "value": "三全鲜食（北新泾店）", "label": "长宁区新渔路144号" }
         ];
      },
      handleSelect(item) {
        // console.log(item,2);
        // this.tagList.push(item)
        // 防止回车选中同时触发
        clearTimeout(this.selectTimer)
        
        if(this.tagList.length>=this.limit){
          this.query=""
          return 
        }
        this.isAll=false
        
        let objChild=this.getQueryTag(this.tagList,item.value)
        if(!objChild.label){
          this.tagList.push({label:item.label,value:item.value})
          this.$emit("initFuc",this.tagList)
          this.$nextTick(()=>{
            this.addShow=false   
            this.query=""   

          })
        }else{
          this.$message({
            type:'error',
            message:"该标签已添加",
            customClass:'select-tag-message'
          }) 
          this.query="" 
        }
        let selectTimer=setTimeout(()=>{
          this.isAll=true
        },50)
      },
      handleClose(idx) {
        this.$emit('removeTag',this.tagList[idx])
        this.tagList.splice(idx, 1);
        this.$emit("initFuc",this.tagList)
      },
      tagBlur(){
        setTimeout(()=>{
          this.creatTag()
          this.isAll=true
          this.addShow=false
        },200)
      }
  },
  mounted() {
      this.$set(this,'tagList',this.initTagList)
      this.searchTag('',()=>{})
      // console.info(this.initTagList,'initTagList')
  }
}
</script>


<style>
  .selectTag-component{
    display: flex;
  }
  
  .selectTag-component .tag-item{
      margin-right: 10px;
      margin-bottom: 10px;
      height: 30px;
      line-height: 30px;
    }
  .selectTag-component .tag-cont{
    width: 50%;
    display: flex;
    flex-wrap:wrap;
  }
  .selectTag-component .search-cont{
    width:40%;
    height: 32px;
    line-height: 32px;
    position: relative;
  }
  .selectTag-component .search-cont .tag-item{
    height: 32px;
    line-height: 32px;
    width:120px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .selectTag-component .search-cont .el-input__inner{
    width:120px;

  }
</style>


// WEBPACK FOOTER //
// src/components/selectTag.vue